import { FieldPath } from 'react-hook-form';
import { EnumMasterSort } from 'view/Layout/enum';
import { EnumMaster, RtnQueryForm } from './init';

export const nameMaster = (
  field: FieldPath<typeof EnumMaster>,
): FieldPath<RtnQueryForm> => `master.${field}`;

export const nameMasterSort = (
  field: EnumMasterSort,
  rowIdx: number,
): FieldPath<RtnQueryForm> => `masterSort.${rowIdx}.${field}`;

/** 排序選項 */
export const propertyOption = [
  { label: '未排序', value: '' },
  { label: '退貨驗收單號碼', value: 'returnNo' },
  { label: '退貨驗收單日期', value: 'returnDate' },
  { label: '退貨通知單號碼', value: 'returnNoteNo' },
  { label: '退貨通知單日期', value: 'returnNoteDate' },
  { label: '分店/倉庫代碼', value: 'buyerGLN' },
  { label: '廠編', value: 'supplierCode' },
];

/** 狀態選項 */
export const statOption = [
  { label: '全部', value: '' },
  { label: '未驗收', value: 'N' },
  { label: '已驗收', value: 'Y' },
];
